import { fetchJSON as fetchAPI } from './client';

export type SprintDashboard = {
  sprint_id: string; objectives: number; qa_modules: number; validation_rules: number;
  provider_interfaces: number; background_jobs: number; quality_gates: number; generated_at: string;
};

export type SprintValidation = {
  valid: boolean; no_conflicting_recommendations: boolean; every_recommendation_validated: boolean;
  evidence_complete: boolean; safety_checks_passed: boolean; business_goals_aligned: boolean;
  marketplace_dna_current: boolean; knowledge_graph_updated: boolean; gaps?: string[];
};

export type Iqa001Status = {
  sprint_id: string; objectives: number; qa_modules: number; intelligence_qa: boolean;
  conflict_detection: boolean; safety_engine: boolean; status: string;
};

const GOVERNANCE_BASE = import.meta.env.VITE_GOVERNANCE_API ?? '/api/v1/governance';
const fetchG = <T,>(path: string, init?: RequestInit) => fetchAPI<T>(`${GOVERNANCE_BASE}${path}`, init);

export const intelligenceQAIqa001Api = {
  dashboard: () => fetchG<SprintDashboard>('/iqa001/dashboard'),
  objectives: () => fetchG<{ objectives: { key: string; name: string; category: string }[] }>('/iqa001/objectives').then((r) => r.objectives),
  qaModules: () => fetchG<{ modules: { key: string; name: string; category: string }[] }>('/iqa001/qa-modules').then((r) => r.modules),
  validationRules: () => fetchG<{ rules: { key: string; name: string; category: string; blocking: boolean }[] }>('/iqa001/validation-rules').then((r) => r.rules),
  providers: () => fetchG<{ providers: { key: string; name: string; interface: string }[] }>('/iqa001/service-architecture').then((r) => r.providers),
  backgroundJobs: () => fetchG<{ jobs: { key: string; name: string; schedule?: string }[] }>('/iqa001/background-jobs').then((r) => r.jobs),
  qualityGates: () => fetchG<{ gates: { key: string; name: string; blocking: boolean }[] }>('/iqa001/quality-gates').then((r) => r.gates),
  validate: (attrs: Record<string, boolean>) =>
    fetchG<SprintValidation>('/iqa001/validate', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ attrs }) }),
  status: () => fetchG<Iqa001Status>('/iqa001/status'),
};
